import React, { useEffect, useState } from 'react';
import '../../styles/selectItem.css';
import PropTypes from 'prop-types';

const SelectItem = (props) => {
  const [selectedIndex, setSelectedIndex] = useState(props.selectedIndex); // selected Option from the select list
  const { updateParentIndex, customClass, selectOption, labelText } = props;

  const updateSelectedIndex = (latestIndex) => {
    setSelectedIndex(latestIndex);
    updateParentIndex && updateParentIndex(latestIndex);
  };

  useEffect(() => {
    if (typeof props.selectedIndex !== 'number') {
      updateSelectedIndex(0);
    }
  }, [props.selectedIndex]);

  const onSelectionChange = (event) => {
    const latestIndex = event.target.selectedIndex;
    updateSelectedIndex(latestIndex);
  };
  return (
    <div className={`${customClass} selectItem`}>
      <label>{labelText}</label>
      <select onChange={onSelectionChange}>
        {selectOption &&
          selectOption.map((item, index) => {
            return (
              <option key={index} selected={index === selectedIndex}>
                {item}
              </option>
            );
          })}
      </select>
    </div>
  );
};

SelectItem.propTypes = {
  updateParentIndex: PropTypes.func,
  selectedIndex: PropTypes.number,
  customClass: PropTypes.string,
  selectOption: PropTypes.array,
  labelText: PropTypes.string
};
export default SelectItem;
